import { CostCenterFromTo } from 'interfaces/CostCenterFromTo';
import { RepositoryParams, api } from '..';

export type CostCenterFromToFilters = Partial<
  CostCenterFromTo & RepositoryParams
>;

export const list = async (params: CostCenterFromToFilters) => {
  return api.get('/centros-custo-de-para', { params });
};

export const listAll = async () => {
  return api.get('/centros-custo-de-para/all');
};

export const retrieve = async (id: string) => {
  return api.get(`/centros-custo-de-para/${id}`);
};

export const create = async (params: CostCenterFromTo) => {
  return api.post('/centros-custo-de-para', { ...params });
};

export const update = async (params: CostCenterFromTo) => {
  return api.patch(`/centros-custo-de-para/${params.id}`, { ...params });
};

export const remove = async (id: string) => {
  return api.delete(`/centros-custo-de-para/${id}`);
};
